export default __webpack_public_path__ + "static/media/brand-image-11.89458667.jpg";